// NOTE: https://github.com/wix-private/site-search/issues/153
var EVENT_PROPERTY = '__settingsEvents';
var eventsVersion = 0;
var eventsQueue = [];
var eventsQueueTimeout;
export function publishSettingsEvent(dataSetter, name, data) {
    // NOTE: public data fire change event with some debounced logic,
    // to be sure series of events are handled, butch events into array before send.
    eventsQueue.push({
        name: name,
        data: data,
    });
    clearTimeout(eventsQueueTimeout);
    eventsQueueTimeout = setTimeout(function () {
        var eventsQueueData = {
            events: eventsQueue,
            version: eventsVersion++,
        };
        dataSetter(EVENT_PROPERTY, eventsQueueData);
        eventsQueue = [];
    }, 100);
}
function checkSettingsEvent(data, prevData, onEvent) {
    var eventsData = data && data[EVENT_PROPERTY];
    var prevEventsData = prevData && prevData[EVENT_PROPERTY];
    if (eventsData &&
        (!prevEventsData || eventsData.version !== prevEventsData.version)) {
        eventsData.events.forEach(function (event) { return onEvent(event.name, event.data); });
    }
}
export function createSettingsEventPublisher(dataSetter) {
    return {
        publish: function (event, eventData) {
            publishSettingsEvent(dataSetter, event, eventData);
        },
    };
}
export function createSettingsEventHandler(initialData, onEvent) {
    var prevData = initialData;
    return {
        updateData: function (data) {
            checkSettingsEvent(data, prevData, onEvent);
            prevData = data;
        },
    };
}
//# sourceMappingURL=settingsPubSub.js.map